module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step.kind === 'redirect') ? _c('div', {
    staticClass: "klickbox-edit-code"
  }, [_c('div', {
    staticClass: "klickbox-code-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.redirect_url')))]), _vm._v(" "), _c('input', {
    staticClass: "klickbox-code-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.step.redirect_url
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateRedirectUrl({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label label__checkbox"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.auto_redirect')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.step.redirect_automatic
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateRedirectAutomatic({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _c('span')])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-0602f79f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/config/Redirect.vue
 ** module id = 750
 ** module chunks = 1
 **/